import PropTypes from "prop-types";

import { strCode } from "../../../../../consts";
import { metricsConfig } from "../../consts/metricsConfig";
import { t } from "../../../../../services";

import { FlexContainers, Paragraph2, WrapperContainer } from "../../../../../components";
import { Circle, Info, LineChartTooltipContainer, MetricsInfo, TooltipHeader } from "./styled";

const metrics = Object.keys(metricsConfig);

export const LineChartTooltip = ({ data, total }) => {
  return (
    <LineChartTooltipContainer Container={FlexContainers.FlexColumnStart}>
      <TooltipHeader Container={FlexContainers.FlexRowBetween} width={"100%"} p={8}>
        <Info>{t(strCode.CONNECTED_USERS_TITLE)}</Info>
        <span>{total}</span>
      </TooltipHeader>

      <MetricsInfo Container={FlexContainers.FlexColumnStart} width={"100%"} p={8} pt={4}>
        {metrics.map((metric) => {
          const config = metricsConfig[metric];
          const total = data[0].metrics[metric];

          return (
            <WrapperContainer
              key={metric}
              Container={FlexContainers.FlexRowBetween}
              gap={8}
              width={"100%"}>
              <WrapperContainer Container={FlexContainers.FlexRowStart} gap={8}>
                <Circle background={config?.color} />
                <Paragraph2>{t(config?.name)}</Paragraph2>
              </WrapperContainer>

              <Info>{total}</Info>
            </WrapperContainer>
          );
        })}
      </MetricsInfo>
    </LineChartTooltipContainer>
  );
};

LineChartTooltip.propTypes = {
  total: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};
